module.exports = __webpack_public_path__ + "img/hamberger_sm_close.e99642e9.png";